
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.914-.002C.817-.002.06.995.06 2.064v13.868c0 1.07.758 2.066 1.855 2.066h1.791c1.098 0 1.854-.997 1.854-2.066V2.064c0-1.07-.756-2.066-1.854-2.066h-1.79zm0 1.467h1.791c.12 0 .389.22.389.6v13.867c0 .38-.268.6-.389.6h-1.79c-.122 0-.39-.22-.39-.6V2.064c0-.38.268-.6.39-.6zM8.223-.002c-1.098 0-1.854.997-1.854 2.066v13.868c0 1.07.756 2.066 1.854 2.066h1.793c1.097 0 1.853-.997 1.853-2.066V2.064c0-1.07-.756-2.066-1.853-2.066H8.223zm0 1.467h1.793c.12 0 .386.22.386.6v13.867c0 .38-.266.6-.386.6H8.223c-.121 0-.387-.22-.387-.6V2.064c0-.38.266-.6.387-.6zM14.39-.002c-1.097 0-1.853.997-1.853 2.066v13.868c0 1.07.756 2.066 1.854 2.066h1.793c1.097 0 1.853-.997 1.853-2.066V2.064c0-1.07-.756-2.066-1.853-2.066H14.39zm0 1.467h1.794c.12 0 .386.22.386.6v13.867c0 .38-.266.6-.386.6H14.39c-.121 0-.387-.22-.387-.6V2.064c0-.38.266-.6.387-.6z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    